<template lang="pug">
  apollo-query(
    :query="query"
    :variables="{ id: studentId }"
    :fetchPolicy="fetchPolicy"
    @result="onResult")
    template(slot-scope="{ result: { loading, error, data } }")
      slot(:sentCurriculums="curriculums") Implement required
</template>

<script>
import { FETCH_SENT_CURRICULUMS_QUERY } from '@/graphql'
import createCurriculum from '@/entities/Curriculum'

export default {
  props: {
    studentId: { type: String },
    fetchPolicy: { type: String, default: 'cache-first' },
  },
  data() {
    return {
      query: FETCH_SENT_CURRICULUMS_QUERY,
      curriculums: [],
    }
  },
  methods: {
    onResult(result) {
      const students = result.data.currentUser.contractedStudents.edges[0]
      this.curriculums = students.node.student.curriculums.edges.map((e) =>
        createCurriculum(e.node)
      )
    },
  },
}
</script>
